import React, {useMemo, useCallback} from "react";
import {useSelector, useDispatch} from "react-redux";
import Image from "./Image";
import {uploaderSelector} from "../../../selectors";
import {uploadImage} from "../../../AC/upload-image";
import Loader from "../../../../common/Loader";
import Button from "@material-ui/core/Button";
import {
  incrementThirdPartySearchPage,
  search
} from "../../../AC/third-party-search";

export function GoogleSearchResults() {
  const dispatch = useDispatch();
  const {
    uploader: {data, loading, loaded}
  } = useSelector((state) => ({
    uploader: uploaderSelector(state)
  }));

  const showMore = useCallback(() => {
    dispatch(incrementThirdPartySearchPage());
    dispatch(search());
  }, [dispatch]);

  const doesNextPageExist = useMemo(
    () =>
      data &&
      data.length &&
      data[data.length - 1].items &&
      data[data.length - 1].queries.nextPage &&
      data[data.length - 1].queries.nextPage[0].count > 0,
    [data]
  );

  return (
    <div className="google-search__content">
      <div className="pictures">
        {loading && !loaded && <Loader />}
        {data &&
          data.map(({items}) => {
            return items ? (
              items.map(({link, image, title}) => {
                const {thumbnailLink: previewSrc} = image;
                return (
                  <div key={link} className="pictures__item">
                    <Image
                      url={link}
                      previewSrc={previewSrc}
                      alt={title}
                      handleClick={(url) => () => dispatch(uploadImage(url))}
                    />
                  </div>
                );
              })
            ) : (
              <span className="no-match">Ничего не найдено</span>
            );
          })}
      </div>
      <div className="pictures__more">
        {doesNextPageExist ? (
          <Button variant="outlined" onClick={showMore}>
            Показать ещё
          </Button>
        ) : null}
      </div>
    </div>
  );
}

GoogleSearchResults.propTypes = {};
